import { useId } from "react";
import Container from "../Container";
import * as S from "./styles";

type Props = {
  label?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  disabled?: boolean;
};

const CustomCheckbox = ({ onChange, checked, label, disabled }: Props) => {
  // The label text renders outside CheckboxWrapper, so it needs an explicit
  // for/id pair; otherwise only the small box toggles the checkbox.
  const inputId = useId();

  return (
    <Container padding="0" gap={1} flat>
      <S.CheckboxWrapper className={disabled ? "disabled" : ""}>
        <S.CheckboxInput
          id={inputId}
          type="checkbox"
          onChange={onChange}
          checked={checked}
          disabled={disabled}
        />
        <S.Checkmark>
          <S.CheckmarkTick />
        </S.Checkmark>
      </S.CheckboxWrapper>
      {label && (
        <S.CheckboxLabel
          htmlFor={inputId}
          className={disabled ? "disabled" : ""}>
          {label}
        </S.CheckboxLabel>
      )}
    </Container>
  );
};

export default CustomCheckbox;
